import { useEffect } from 'react';
import store from '../store';

const useReduxReducer = (reducers) => {
  useEffect(() => {
    Object.keys(reducers).forEach((reducerKey) => {
      store.reducerManager.add(reducerKey, reducers[reducerKey]);
    })
    return () => {
      Object.keys(reducers).forEach((reducerKey) => {
        store.reducerManager.remove(reducerKey);
      })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useReduxReducer;
